import { Layout } from '@/Layout'
import { OrganizationMembers } from '@/templates/OrganizationMembers'
import { Teams } from '@/templates/Teams'
import { InvitePopup } from '@/components/InvitePopup'
import { Tabs } from '@/components/Tabs'
import { useUser } from '@/hooks/useUser'

export const Organization = () => {
  const { user } = useUser()

  const tabs = [
    {
      id: 'teams',
      label: 'Teams',
      content: <Teams organizationId={user?.organizationId} />,
      action: <InvitePopup organizationId={user?.organizationId!} />,
    },
    { id: 'members', label: 'Members', content: <OrganizationMembers /> },
  ]
  return (
    <Layout title="Organization" showBackButton showCreateButton={false}>
      <Tabs tabs={tabs} defaultTab="teams" />
    </Layout>
  )
}
